export const CS_QUERY_AND_OPERATOR = '$and';
export const CS_QUERY_OR_OPERATOR = '$or';
export const CS_QUERY_ARRAY_EQUALS_OPERATOR = '$in';
export const CS_QUERY_TAGS = 'tags';
export const getTagInQueryPart = (tag) => ({
    [CS_QUERY_TAGS]: {
        [CS_QUERY_ARRAY_EQUALS_OPERATOR]: [tag],
    },
});
export const getTagsQueryObject = (tags, operator = CS_QUERY_AND_OPERATOR) => {
    return (tags ?? []).reduce((acc, tag) => {
        acc[operator].push(getTagInQueryPart(tag));
        return acc;
    }, { [operator]: [] });
};
//# sourceMappingURL=tags.js.map